const RELOAD_KEY = "kitsulab:chunk-reload";
let reloadRequested = false;

export function isChunkLoadError(error: unknown): boolean {
	return error instanceof TypeError && /^(Failed to fetch dynamically imported module:|error loading dynamically imported module:|Importing a module script failed\.?$)/i.test(error.message);
}

export function reloadAfterChunkError(error: unknown): boolean {
	if (!isChunkLoadError(error) || !navigator.onLine) return false;
	if (reloadRequested) return true;
	try {
		if (sessionStorage.getItem(RELOAD_KEY)) return false;
		sessionStorage.setItem(RELOAD_KEY, "1");
		window.location.reload();
		reloadRequested = true;
		return true;
	} catch {
		return false;
	}
}
